import { getPageAllowedRoles } from "../../config/roles";
import {
  fullWidth,
  halfWidth,
} from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import { BlacklistAudits } from "./BlacklistAudits";
import { BlacklistCheck } from "./BlacklistCheck";
import { MailExclusionCheck } from "./MailExclusionCheck";

/** Checking and lifting suppressions, with the history of those lifted. */
export const blacklistPageDefinition: PageDefinition = {
  path: "/blacklist",
  title: "Blacklist and Mail Exclusion",
  allowedRoles: getPageAllowedRoles("blacklist"),
  rows: [
    {
      id: "row-checks",
      panels: [
        {
          id: "panel-blacklist",
          title: "Blacklist",
          helperText:
            "The blacklist is a list of email addresses that have been deemed to be permanently unreachable due to receiving hard bounces from the destination mail server or DNS.",
          span: halfWidth,
          component: BlacklistCheck,
        },
        {
          id: "panel-mail-exclusion",
          title: "Mail Exclusion",
          helperText:
            "The mail exclusion is a list of email addresses to which mail cannot be sent. These usually come from feedback loop notifications, where the recipient has reported the email as spam.",
          span: halfWidth,
          component: MailExclusionCheck,
        },
      ],
    },
    {
      id: "row-audits",
      panels: [
        {
          id: "panel-audits",
          title: "Audits",
          span: fullWidth,
          component: BlacklistAudits,
        },
      ],
    },
  ],
};
